import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";
import { map, publishReplay, refCount } from "rxjs/operators";

@Injectable()
export class CurrentUserService {
  private currentUser: Observable<CurrentUser>;

  constructor(private apiHttp: ApiHttpService) {}

  public get = (): Observable<CurrentUser> => {
    if (!this.currentUser) {
      this.currentUser = this.apiHttp.get<CurrentUser>('currentuser').pipe(
        map(u => u),
        publishReplay(),
        refCount()
      );
    }

    return this.currentUser;
  };
    
  public clear() {
    this.currentUser = null;
  };
}

export interface CurrentUser {
  id: number;
  userName: string;
  email: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  ceMember: boolean;
  isActive: boolean;
  roles: UserRoles;
}

export enum UserRoles {
  None = 0,
  Requestor = 1,
  CollaboratorLiaison = 2,
  TacticalLiaison = 4,
  ExperimentCreator = 8
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/current-user.service.ts